// Hero Block Animation
($ => {
    // Create a global object to store hero timelines
    window.heroAnimations = window.heroAnimations || {
        timelines: new Map(),
        setInitialState: function(heroContent) {
            // Set initial states for hero content and its children
            gsap.set(heroContent, {
                opacity: 0,
                y: 100
            });

            const contentElements = heroContent.children;
            gsap.set(contentElements, {
                opacity: 0,
                y: 100
            });
        },
        init: function() {
            const heroClass = '.ttr-hero';
            const heroContents = document.querySelectorAll(`${heroClass}__content`);

            heroContents.forEach((heroContent, index) => {
                // Set initial states using the utility function
                this.setInitialState(heroContent);

                // Create timeline for the animation
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: heroContent,
                        start: "top 80%",
                        toggleActions: "play none none reverse",
                        // markers: true
                    }
                });

                // Animate the content container first
                tl.to(heroContent, {
                    duration: 1,
                    opacity: 1,
                    y: 0,
                    ease: "back.out",
                    once: true
                })
                // Then stagger animate all children
                .to(heroContent.children, {
                    duration: 0.5,
                    opacity: 1,
                    y: 0,
                    stagger: 0.15,
                    ease: "back.out",
                    once: true
                }, "-=0.8"); // Overlap with the container animation

                // Store the timeline in our global map
                this.timelines.set(heroContent, tl);
            });
        },
        getTimeline: function(heroContent) {
            return this.timelines.get(heroContent);
        }
    };

    // Initialize hero animations
    window.heroAnimations.init();

})(jQuery);
